import { useState, useEffect } from "react";

// Determines login state by asking the server (via the HttpOnly session
// cookie set on successful /api/login), rather than trusting anything
// readable/writable from client-side JavaScript.
export default function useAuth() {
    const [authenticated, setAuthenticated] = useState(null); // null = still checking

    useEffect(() => {
        let ignore = false;
        fetch('/api/me')
            .then(res => { if (!ignore) setAuthenticated(res.ok); })
            .catch(() => { if (!ignore) setAuthenticated(false); });
        return () => { ignore = true; };
    }, []);

    const markAuthenticated = () => setAuthenticated(true);

    return {
        authenticated,
        markAuthenticated
    };
}
